import { motion } from 'framer-motion';

interface FeatureRowProps {
	title: string;
	desc: string;
	bullets: string[];
	media?: React.ReactNode;
	reverse?: boolean;
}

export default function FeatureRow({ title, desc, bullets, media, reverse }: FeatureRowProps) {
	return (
		<section className="py-12 md:py-16">
			<div className={`container grid md:grid-cols-2 gap-8 items-center ${reverse ? 'md:[&>div:first-child]:order-2' : ''}`}>
				<motion.div 
					initial={{ opacity: 0, y: 10 }} 
					animate={{ opacity: 1, y: 0 }} 
					transition={{ duration: 0.6, delay: 0.2 }}
				>
					<h3 className="text-2xl font-semibold text-gradient">{title}</h3>
					<p className="mt-2 text-gray-600">{desc}</p>
					<ul className="mt-4 space-y-2 text-gray-700 list-disc list-inside">
						{bullets.map((b) => (<li key={b}>{b}</li>))}
					</ul>
				</motion.div>
				<motion.div 
					initial={{ opacity: 0, y: 10 }} 
					animate={{ opacity: 1, y: 0 }} 
					transition={{ duration: 0.6, delay: 0.4 }}
					className="p-4"
				>
					{media || <div className="h-48 md:h-64 w-full rounded-md bg-gradient-to-br from-babyblue via-royalpurple to-orangepeel opacity-70" />}
				</motion.div>
			</div>
		</section>
	);
}
